module.exports = __webpack_public_path__ + "media/images/icon_list/campaign-948f5c26bfd880d15edc20360a6d5d31.svg";